import { h } from "preact";
import { useLayoutEffect, useState } from "preact/hooks";

import waitingListApi from "../api/waitingList";
import * as validators from "../validators";

import ModalForm from "./ModalForm.jsx";
import SubmitButton from "./SubmitButton.jsx";
import TextField from "./TextField.jsx";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrentHint, setShowWaitingListModal } from "../store";
import { sendError } from "../errors";
import i18n from "../i18n";

function isValid(value, validations) {
  return validations.reduce((result, validator) => {
    if (result === true) {
      return validators[validator](value);
    }
    return result;
  }, true);
}

const validations = ["required", "email"];

export default function WaitingListModal() {
  const [value, setValue] = useState("");
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [validOrError, setValidOrError] = useState(true);
  const [serverError, setServerError] = useState(false);
  const opened = useSelector((state) => state.ui.showWaitingListModal);

  const dispatch = useDispatch();

  function handleModalClose(event) {
    event && event.preventDefault();
    dispatch(setShowWaitingListModal(false));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setServerError(null);
    if (true == isValid(value, validations)) {
      setSending(true);
      try {
        await waitingListApi.enter(value);
        setSuccess(true);
        setTimeout(function () {
          dispatch(setShowWaitingListModal(false));
        }, 1000);
        await dispatch(fetchCurrentHint());
      } catch (err) {
        sendError(err);
        setServerError(i18n.t("component.waiting_list_modal.server_error"));
      }
      setSending(false);
    }
  }

  function handleInputChange(event) {
    checkValidation(event.target.value);
  }

  function checkValidation(newValue) {
    setValue(newValue);
    setValidOrError(isValid(newValue, validations));
  }

  return (
    <ModalForm
      onClose={handleModalClose}
      onSubmit={handleSubmit}
      buttonRow={
        <SubmitButton
          sending={sending}
          success={success}
          class="mt-16"
          disabled={!value || validOrError !== true}
        >
          {i18n.t("component.waiting_list_modal.button")}
        </SubmitButton>
      }
      error={serverError}
      opened={opened}
    >
      <p>{i18n.t("component.waiting_list_modal.description")}</p>
      <p class="mb-40">
        <TextField
          value={value}
          onUpdate={checkValidation}
          error={validOrError === true ? null : validOrError}
          options={{ validation: "email" }}
          placeholder={i18n.t("component.waiting_list_modal.email_placeholder")}
          onChange={handleInputChange}
        />
      </p>
    </ModalForm>
  );
}
